// extracted by mini-css-extract-plugin
module.exports = {"toggle":"select_toggle__2tSGi","dropdown":"select_dropdown__1mgeD"};